import React from "react";
import {Table, Button, Row, Col, Modal, Checkbox} from "react-bootstrap";
import Loading from "components/Loading";
import {Link} from "react-router-dom";
import moment from "moment";
import Request from "request";
import {getClientNickname} from "tools";

class TicketDetails extends React.Component {
	state = {
		ticket: null,
		filter_client_unique: false
	};

	constructor(props, context) {
		super(props, context);

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.fetchTicket(this.props.ticket);
	}
	UNSAFE_componentWillReceiveProps() {
		this.fetchTicket(this.props.ticket);
	}

	fetchTicket(ticket) {
		const {event} = this.props;
		Request.get(`/api/cp/event/${event.eventPassword}/ticket/${ticket.ticket}`)
			.then(ticket => this.setState({ticket}))
		;
	}

	handleChange(e) {
		const name = e.target.name;
		const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

		switch(name) {
			case 'filter_client_unique': this.setState({filter_client_unique: value}); break;
		}
	}

	renderTicketInfo() {
		const {event} = this.props;
		const {ticket} = this.state;
		let sessions = ticket.session || [];

		if (this.state.filter_client_unique) {
			sessions = sessions.filter((session, index, sessions) => {
				return sessions.findIndex(s => s.deviceId === session.deviceId) === index;
			});
		}

		return (
			<section>
				<Row>
					<Col xs={6}><h5>Входы</h5></Col>
					<Col xs={6}><Checkbox name="filter_client_unique" checked={this.state.filter_client_unique} onChange={this.handleChange}>Только уникальные зрители</Checkbox></Col>
				</Row>
				<Table>
					<thead>
					<tr>
						<th width="150">Время входа</th>
						<th>Зритель</th>
					</tr>
					</thead>
					<tbody>
					{sessions.map(session =>
						<tr key={`ticket-session-${session.id}`}>
							<td>{moment.unix(session.time).format('YYYY-MM-DD HH:mm:ss')}</td>
							<td>
								{session.client ?
									<Link to={`/event/${event.eventPassword}/client/${session.client.id}`}>{getClientNickname(session.client)}</Link>
									:
									`Не авторизованный зритель №${session.deviceId}`
								}
							</td>
						</tr>
					)}
					</tbody>
				</Table>
			</section>
		);
	}

	renderLoading() {
		return <Loading>Загрузка данных билета</Loading>;
	}

	render() {
		const {event, onHide} = this.props;
		const {ticket} = this.state;

		return (
			<Modal show={true} onHide={onHide}>
				<Modal.Header closeButton>
					<Modal.Title>Информация о билете</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ticket ? this.renderTicketInfo() : this.renderLoading()}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.props.onHide}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default TicketDetails;
